import React from "react";

import { Document, Page } from "@react-pdf/renderer";
import { Row, Col } from "antd";
import FeeInvoicePart1 from "./FeeInvoicePart1";
import FeeInvoicePart2 from "./FeeInvoicePart2";
import FeeInvoicePart3 from "./FeeInvoicePart3";

const PropertyPhTenPdf = ({ data }) => (
  <Document>
    <Page pageNumber={1} wrap>
      {/* <Row style={{width: 1515}}> */}
      <Row>
        <Col span={8}>
          <FeeInvoicePart1 data={data} />
        </Col>
        <Col span={8}>
          <FeeInvoicePart2 data={data} />
        </Col>
        <Col span={8}>
          <FeeInvoicePart3 data={data} />
        </Col>
      </Row>
    </Page>
  </Document>
);

export default PropertyPhTenPdf;
